'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
var colors = require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
var input = require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
var pill = require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var useClickInside = require('../../../../hooks/use-click-inside.js');
var useDebounce = require('../../../../hooks/use-debounce.js');
var key = require('../../../../utilities/key.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
var useIntersectionObserver = require('../../../../hooks/use-intersection-observer.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../atoms/icon/font-icon/font-icon.js');
require('react-transition-group');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('react-laag');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('@brandfolder/utilities');
require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
require('../../../atoms/button/icon-button/icon-button.js');
require('../../../atoms/button/standard-button/standard-button.js');
require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
require('../../../atoms/heading/standard-heading/standard-heading.js');
require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
var standardPill = require('../../../atoms/pill/standard/standard-pill.js');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
require('../../../atoms/text/help-text/help-text.js');
require('../../../atoms/text/standard-text/standard-text.js');
require('../../../internal/list/standard-list/standard-list.js');
require('../../../internal/listbox/standard-listbox/standard-listbox.js');
require('../../../internal/listitem/standard-listitem/standard-listitem.js');
require('../../../internal/option/standard-option/standard-option.js');
var fakeTextarea = require('../../../internal/textarea/fake-textarea.js');
require('../../../internal/textfield/textfield-addon.js');
var textfieldBody = require('../../../internal/textfield/textfield-body.js');
var textfieldHeader = require('../../../internal/textfield/textfield-header.js');
require('../../../internal/textfield/textfield-icon.js');
require('../../../internal/textfield/textfield-inner.js');
var textfieldWrapper = require('../../../internal/textfield/textfield-wrapper.js');
var standardCombobox = require('../../combobox/standard-combobox/standard-combobox.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const DEFAULT_DUPLICATE_CHECK = (options)=>options.tag.value.toString().trim().toLocaleLowerCase(options.locale) === options.value.trim().toLocaleLowerCase(options.locale);
/**
 * Newline, carriage return, comma, semicolon, pipe.
 * Intentionally not delimiting on `@` and `.` for emails.
 * Intentionally not delimited on `:` for URL's.
 */ const DEFAULT_DELIMITER = /[\n\r,;|]/;
const BaseStandardTagger = (props)=>{
    const { addTags , allowBackspaceRemove , allowCustomValue , allowDelimited , allowDuplicates , allowTagsOnBlur , allowTagsOnPaste , bodyProps , className , clearTags , comboboxProps , delimiter =DEFAULT_DELIMITER , disabled , duplicateCheck , error , errorProps , headerProps , height , helpText , helpTextProps , id , initialTags , labelPosition , labelProps , labels , loading , locale , look , onTagged , options =[] , readOnly , required , search , showLabel , tagFormatter , textareaProps , ...otherProps } = props;
    const { duplicateOptionLabel , emptyLabel , iconButtonLabel , label , listboxLabel , loaderLabel , removeTagLabel , requiredLabel  } = labels;
    const enabled = !disabled && !readOnly;
    const hasError = !!error;
    const hasHelpText = !!helpText;
    const hasHeight = height !== undefined;
    const hasRequired = required && !!requiredLabel;
    const helpTextId = `${id}-help-text`;
    const inlineAlertId = `${id}-inline-alert`;
    const labelId = `${id}-label`;
    const textareaId = `${id}-textarea`;
    const textfieldWrapperId = `${id}-textfield-wrapper`;
    const comboboxTextareaRef = React.useRef(null);
    const fakeTextareaRef = React.useRef(null);
    const wrapperRef = React.useRef(null);
    const { clickedInside  } = useClickInside.useClickInside({
        ref: wrapperRef
    });
    const { intersecting  } = useIntersectionObserver.useIntersectionObserver({
        intersectionObserverOptions: {
            root: fakeTextareaRef.current,
            threshold: 0.5
        },
        ref: comboboxTextareaRef
    });
    const [duplicate, setDuplicate] = React.useState(false);
    const [focused, setFocused] = React.useState(false);
    const [expanded, setExpanded] = React.useState(false);
    const [overflow, setOverflow] = React.useState(false);
    const [reset, setReset] = React.useState(false);
    const [selectedAllTags, setSelectedAllTags] = React.useState(false);
    const [selectedTagIndex, setSelectedTagIndex] = React.useState(undefined);
    const [tags, setTags] = React.useState(initialTags || []);
    const [toggleExpanded, setToggleExpanded] = React.useState(undefined);
    const [value, setValue] = React.useState('');
    // this debounce is only applied when the combobox input has no value
    // so that a user pressing backspace doesn't remove a tag accidentally
    const valueDebounced = useDebounce.useDebounce(value, value === '' ? 300 : 0);
    const hasSelectedTagIndex = selectedTagIndex !== undefined;
    const hasTags = tags.length > 0;
    const hasValue = value !== '';
    const hasValueDebounced = valueDebounced !== '';
    const lastTagIndex = tags.length - 1;
    const scrollToCombobox = ()=>{
        if (!intersecting) {
            comboboxTextareaRef?.current?.scrollIntoView({
                behavior: 'auto',
                block: 'end'
            });
        }
    };
    const focusCombobox = ()=>{
        if (comboboxTextareaRef.current) {
            comboboxTextareaRef.current.focus({
                preventScroll: true
            });
        }
    };
    const deselectTags = ()=>{
        if (allowBackspaceRemove) {
            setSelectedAllTags(false);
            setSelectedTagIndex(undefined);
        }
    };
    const resetTagger = ()=>{
        deselectTags();
        setReset(true);
        setValue('');
    };
    const createOption = (val)=>{
        const trimmed = val.toString().trim();
        return {
            children: trimmed,
            key: key.generateKey(),
            label: trimmed,
            value: trimmed,
            type: 'create'
        };
    };
    const createTagFromValue = (val)=>{
        const option = createOption(val);
        const newTags = [
            ...tags,
            option
        ];
        setTags(newTags);
        onTagged(newTags, 'create', option);
        resetTagger();
    };
    const createTagsFromValue = (val)=>{
        // separate values on delimiter and filter out empty strings
        const values = val.toString().split(delimiter).filter(Boolean);
        const newTags = [
            ...tags,
            ...values.map((v)=>createOption(v))
        ];
        setTags(newTags);
        onTagged(newTags, 'create');
        resetTagger();
    };
    const onSelection = (option, _, val)=>{
        if (option) {
            const newTags = [
                ...tags,
                option
            ];
            setTags(newTags);
            onTagged(newTags, 'select', option);
        } else if (allowCustomValue && val) {
            if (allowDelimited && delimiter.test(val.toString())) {
                createTagsFromValue(val);
            } else {
                createTagFromValue(val);
            }
        }
        resetTagger();
        setTimeout(()=>{
            scrollToCombobox();
        }, 50);
    };
    const onRemove = (key)=>{
        const option = tags.find((tag)=>tag.key === key);
        const newTags = tags.filter((tag)=>tag.key !== key);
        setTags(newTags);
        onTagged(newTags, 'remove', option);
        resetTagger();
        focusCombobox();
    };
    const removeAll = ()=>{
        setTags([]);
        resetTagger();
    };
    React.useEffect(()=>{
        if (addTags && addTags.length > 0) {
            const newTags = [
                ...tags,
                ...addTags.map((tag)=>{
                    tag.type = 'external';
                    return tag;
                })
            ];
            setTags(newTags);
        }
    }, [
        addTags
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (clearTags) {
            removeAll();
        }
    }, [
        clearTags
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (reset) {
            setReset(false);
        }
    }, [
        reset
    ]);
    React.useEffect(()=>{
        if (fakeTextareaRef.current) {
            setOverflow(fakeTextareaRef.current?.scrollHeight > fakeTextareaRef.current?.clientHeight);
        }
    }, [
        fakeTextareaRef.current?.scrollHeight,
        fakeTextareaRef.current?.clientHeight
    ]);
    React.useEffect(()=>{
        if (toggleExpanded !== undefined) {
            setToggleExpanded(undefined);
        }
    }, [
        toggleExpanded
    ]);
    const pillElement = 'p';
    return /*#__PURE__*/ React__default.default.createElement(textfieldWrapper.TextfieldWrapper, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-tagger': true,
            'bf-tagger__standard': true,
            'bf-tagger__standard--disabled': disabled,
            'bf-tagger__standard--error': hasError,
            'bf-tagger__standard--expanded': expanded,
            'bf-tagger__standard--focused': focused,
            'bf-tagger__standard--help-text': hasHelpText,
            'bf-tagger__standard--label-hidden': !showLabel,
            [`bf-tagger__standard--label-${labelPosition}`]: showLabel,
            [`bf-tagger__standard--look-${look}`]: look,
            'bf-tagger__standard--height': hasHeight,
            'bf-tagger__standard--overflow': overflow,
            'bf-tagger__standard--readonly': readOnly,
            'bf-tagger__standard--required': hasRequired,
            'bf-tagger__standard--selected-all': selectedAllTags,
            [`${className}`]: !!className
        }),
        "data-testid": textfieldWrapperId,
        id: textfieldWrapperId,
        labelPosition: labelPosition,
        onClick: enabled ? (e)=>{
            const target = e.target;
            const { tagName  } = target;
            // exclude focusing on the combobox when clicking on a pill
            // so that users can copy the pill text, if needed
            if (![
                pillElement.toUpperCase()
            ].includes(tagName)) {
                focusCombobox();
            }
            if (otherProps?.onClick) {
                otherProps.onClick(e);
            }
        } : undefined,
        ref: wrapperRef
    }), /*#__PURE__*/ React__default.default.createElement(textfieldHeader.TextfieldHeader, _extends({}, headerProps, {
        className: classnames__default.default({
            'bf-tagger__header': true,
            [`${headerProps?.className}`]: !!headerProps?.className
        }),
        error: duplicate ? duplicateOptionLabel : error,
        errorProps: errorProps,
        htmlFor: `${id}-combobox`,
        inlineAlertId: inlineAlertId,
        label: label,
        labelId: labelId,
        labelPosition: labelPosition,
        labelProps: labelProps,
        required: required,
        requiredLabel: requiredLabel,
        showLabel: showLabel
    })), /*#__PURE__*/ React__default.default.createElement(textfieldBody.TextfieldBody, _extends({}, bodyProps, {
        className: classnames__default.default({
            'bf-tagger__body': true,
            [`${bodyProps?.className}`]: !!bodyProps?.className
        }),
        error: duplicate ? duplicateOptionLabel : error,
        errorProps: errorProps,
        helpText: helpText,
        helpTextId: helpTextId,
        helpTextProps: helpTextProps,
        inlineAlertId: inlineAlertId,
        labelPosition: labelPosition
    }), /*#__PURE__*/ React__default.default.createElement(fakeTextarea.FakeTextarea, _extends({}, textareaProps, {
        "data-testid": textareaId,
        disabled: disabled,
        error: duplicate ? duplicateOptionLabel : error,
        focused: focused,
        id: textareaId,
        look: look,
        readOnly: readOnly,
        ref: fakeTextareaRef
    }), tags.map((tag, index)=>{
        const current = index === selectedTagIndex;
        const currentOrSelectedAll = selectedAllTags || current;
        return /*#__PURE__*/ React__default.default.createElement(standardPill.StandardPill, {
            "aria-current": current || undefined,
            backgroundColor: enabled ? colors.BrandfolderHexColors.DirtyMarshmallow : colors.BrandfolderHexColors.Gray,
            borderColor: enabled && currentOrSelectedAll ? colors.BrandfolderHexColors.GrayMediumDark : enabled ? colors.BrandfolderHexColors.DirtyMarshmallow : colors.BrandfolderHexColors.Gray,
            closeButtonAriaLabel: removeTagLabel,
            fontColor: colors.BrandfolderHexColors.Text,
            element: pillElement,
            ellipsis: false,
            error: tag.error,
            key: tag.key,
            onClose: enabled ? ()=>{
                onRemove(tag.key);
            } : undefined,
            size: pill.PillSize.Large
        }, tagFormatter ? tagFormatter(tag) : tag.children);
    }), /*#__PURE__*/ React__default.default.createElement(standardCombobox.StandardCombobox, _extends({}, comboboxProps, {
        allowCustomValue: allowCustomValue,
        clearAfterCustomValue: true,
        reset: reset,
        comboboxTextareaProps: {
            ...comboboxProps?.comboboxTextareaProps,
            onBlur: (e)=>{
                deselectTags();
                setFocused(false);
                if (allowCustomValue && allowTagsOnBlur && !clickedInside && value) {
                    if (allowDelimited && delimiter.test(value.toString())) {
                        createTagsFromValue(value);
                    } else {
                        createTagFromValue(value);
                    }
                }
                if (comboboxProps?.comboboxTextareaProps?.onBlur) {
                    comboboxProps?.comboboxTextareaProps?.onBlur(e);
                }
            },
            onChange: (e)=>{
                const { target  } = e;
                deselectTags();
                setValue(target.value);
                if (!allowDuplicates) {
                    const manualDuplicate = !!tags.some((tag)=>duplicateCheck ? duplicateCheck({
                            locale,
                            tag,
                            value: target.value
                        }) : DEFAULT_DUPLICATE_CHECK({
                            locale,
                            tag,
                            value: target.value
                        }));
                    setDuplicate(manualDuplicate);
                }
                if (comboboxProps?.comboboxTextareaProps?.onChange) {
                    comboboxProps?.comboboxTextareaProps?.onChange(e);
                }
            },
            onFocus: (e)=>{
                setFocused(true);
                if (comboboxProps?.comboboxTextareaProps?.onFocus) {
                    comboboxProps?.comboboxTextareaProps?.onFocus(e);
                }
            },
            onKeyDown: (e)=>{
                const { ctrlKey , key , metaKey  } = e;
                if (allowBackspaceRemove && hasTags && !hasValue && (ctrlKey || metaKey) && key === 'a') {
                    setSelectedAllTags(true);
                    setToggleExpanded(false);
                }
                if (key === 'ArrowDown' || key === 'ArrowUp') {
                    deselectTags();
                    scrollToCombobox();
                }
                if (comboboxProps?.comboboxTextareaProps?.onKeyDown) {
                    comboboxProps?.comboboxTextareaProps?.onKeyDown(e);
                }
            },
            onKeyUp: (e)=>{
                const { key  } = e;
                if (allowCustomValue && allowDelimited && delimiter.test(value.toString())) {
                    createTagsFromValue(value);
                }
                if (allowBackspaceRemove && hasTags) {
                    switch(key){
                        case 'ArrowLeft':
                            {
                                if (!hasValue && !selectedAllTags) {
                                    setToggleExpanded(false);
                                    if (selectedTagIndex === undefined) {
                                        setSelectedTagIndex(lastTagIndex);
                                    } else if (selectedTagIndex !== 0) {
                                        setSelectedTagIndex(selectedTagIndex - 1);
                                    }
                                // if selectedTagIndex === 0, do nothing (can't go further left)
                                }
                                break;
                            }
                        case 'ArrowRight':
                            {
                                if (!hasValue && !selectedAllTags) {
                                    setSelectedAllTags(false);
                                    if (selectedTagIndex === lastTagIndex) {
                                        setSelectedTagIndex(undefined);
                                    } else if (hasSelectedTagIndex) {
                                        setSelectedTagIndex(selectedTagIndex + 1);
                                    }
                                // if selectedTagIndex === undefined, do nothing (can't go right)
                                }
                                break;
                            }
                        case 'Backspace':
                        case 'Delete':
                            {
                                if (selectedAllTags || hasSelectedTagIndex || !hasValueDebounced) {
                                    if (selectedAllTags) {
                                        removeAll();
                                    } else if (hasSelectedTagIndex) {
                                        onRemove(tags[selectedTagIndex].key);
                                    } else if (!hasValueDebounced) {
                                        // eslint-disable-next-line unicorn/prefer-at
                                        onRemove(tags[tags.length - 1].key);
                                    }
                                }
                                break;
                            }
                        case 'Escape':
                            {
                                deselectTags();
                                break;
                            }
                    }
                }
                if (comboboxProps?.comboboxTextareaProps?.onKeyUp) {
                    comboboxProps?.comboboxTextareaProps?.onKeyUp(e);
                }
            },
            onPaste: (e)=>{
                deselectTags();
                const pasted = e.clipboardData.getData('text');
                if (allowCustomValue && allowTagsOnPaste && pasted) {
                    if (allowDelimited && delimiter.test(pasted.toString())) {
                        createTagsFromValue(pasted);
                    } else {
                        createTagFromValue(pasted);
                    }
                    e.preventDefault(); // stops onChange when pasting
                }
                if (comboboxProps?.comboboxTextareaProps?.onPaste) {
                    comboboxProps?.comboboxTextareaProps?.onPaste(e);
                }
            },
            ref: comboboxTextareaRef
        },
        disabled: disabled,
        disabledOptions: tags,
        duplicate: duplicate,
        inlineAlertId: inlineAlertId,
        editable: true,
        error: duplicate ? duplicateOptionLabel : error,
        helpText: helpText,
        helpTextId: helpTextId,
        id: id,
        labelId: labelId,
        labels: {
            emptyLabel,
            iconButtonLabel,
            label: '',
            listboxLabel,
            loaderLabel,
            requiredLabel: '' // intentionally blank
        },
        loading: loading,
        locale: locale,
        onExpanded: setExpanded,
        onSelection: onSelection,
        options: options,
        parentScrolls: hasHeight,
        readOnly: readOnly,
        required: required,
        search: search,
        showIconButton: false,
        showLoadingOption: true,
        showPlaceholderOption: false,
        tagger: true,
        toggleExpanded: toggleExpanded
    })))));
};
const getHeight = (height)=>{
    if (height === undefined) return styled.css`
      min-height: 142px;
    `;
    return styled.css`
    height: ${height}px;
    overflow-y: auto;
  `;
};
const Tagger = styled__default.default(BaseStandardTagger)`
  .bf-tagger__tags {
    flex-shrink: 0;
    max-width: 100%;
  }

  .bf-textarea__fake {
    align-content: flex-start;
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
    padding: 5px;
    ${({ height  })=>getHeight(height)}
  }

  &.bf-tagger__standard--expanded.bf-tagger__standard--height.bf-tagger__standard--overflow {
    .bf-textarea__fake {
      overflow: hidden;
    }
  }

  .bf-combobox__standard {
    flex: 1;
    margin: 3px 0 0;
    max-width: 100%;
    min-width: 280px;
  }

  .bf-combobox__combobox {
    border: 0;
    min-height: 0;
    padding: 10px;
  }

  .bf-listbox__standard {
    width: 280px;
  }

  .bf-pill__standard {
    align-items: center;
    cursor: default;
    height: auto;
    margin: 5px;
    padding: 7px 7px 7px 10px;

    .bf-pill__content {
      height: auto;
      line-height: 20px;
      overflow-wrap: anywhere;
      padding: 0;
    }

    .bf-pill__close-button {
      height: 15px;
      margin-top: 1px;
      margin-inline-start: 7px;
      padding: 0;
      width: 15px;

      .bf-pill__close-icon {
        font-size: 10px;
      }
    }
  }
`;
/**
 * A component for creating and displaying tags selected from a `<StandardCombobox>`.
 *
 * @param props StandardTaggerProps
 * @returns FunctionComponent<StandardTaggerProps>
 */ const StandardTagger = (props)=>{
    const { allowBackspaceRemove =true , allowCustomValue =true , allowDelimited =true , allowDuplicates =true , allowTagsOnBlur =true , allowTagsOnPaste =true , labelPosition =input.InputLabelPositions.Top , look =input.InputLooks.Default , search =true , showLabel =true , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Tagger, _extends({}, otherProps, {
        allowBackspaceRemove: allowBackspaceRemove,
        allowDelimited: allowDelimited,
        allowCustomValue: allowCustomValue,
        allowDuplicates: allowDuplicates,
        allowTagsOnBlur: allowTagsOnBlur,
        allowTagsOnPaste: allowTagsOnPaste,
        labelPosition: labelPosition,
        look: look,
        search: search,
        showLabel: showLabel
    })));
};

exports.BaseStandardTagger = BaseStandardTagger;
exports.DEFAULT_DELIMITER = DEFAULT_DELIMITER;
exports.DEFAULT_DUPLICATE_CHECK = DEFAULT_DUPLICATE_CHECK;
exports.StandardTagger = StandardTagger;
//# sourceMappingURL=standard-tagger.js.map
